module.exports = __webpack_public_path__ + "media/transport_protocols/Cancellations-b927c849.svg";